<template>
  <div class="doctorManage">
    <div>
      <div>
        <div class="seach">
          <el-form class="form" ref="form" :model="form" :inline="true" @submit.native.prevent>
            <el-form-item label="医生名称">
              <el-input
                v-model="form.doctor_name"
                placeholder="请输入"
                class="setUp-doctor-word"
                clearable
              />
            </el-form-item>
            <el-form-item label="所属医院">
              <el-input
                v-model="form.hospital"
                placeholder="请输入"
                class="setUp-doctor-word"
                clearable
              />
            </el-form-item>
            <el-form-item label="注册状态">
              <el-select v-model="form.is_registered" clearable>
                <el-option
                  v-for="(value, key) in statusMap.isRegistered"
                  :label="value"
                  :value="key"
                  :key="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="认证状态">
              <el-select v-model="form.verify_status" clearable>
                <el-option
                  v-for="(value, key) in statusMap.verifyStatus"
                  :label="value"
                  :value="key"
                  :key="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签约状态">
              <el-select v-model="form.contract_status" clearable>
                <el-option
                  v-for="(value, key) in statusMap.contractStatus"
                  :label="value"
                  :value="key"
                  :key="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属科室">
              <el-select v-model="form.department" placeholder="请选择" clearable>
                <el-option
                  v-for="item in departmentList"
                  :key="item.department_id"
                  :label="item.department_name"
                  :value="item.department_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="医生职称">
              <el-select v-model="form.title_name" placeholder="请选择医生职称" clearable>
                <el-option
                  v-for="item in titleList"
                  :key="item.title_id"
                  :value="item.title_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                class="btn"
                type="primary"
                :loading="buttonLoading"
                @click="doctorOnSubmit"
              >
                筛选
              </el-button>
            </el-form-item>
            <ExportProgress ref="downloadDialog"></ExportProgress>
            <ExportExcel
              :config-name="$options.name"
              :excel-data="excelData"
              :is-loading="isExportLoading"
              @emit="handleExportExcel"
            ></ExportExcel>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="table-list">
          <el-table :data="tableSetupList" style="width: 100%" v-loading="doctorTableLoading">
            <template slot="empty">
              <!-- 没有数据 -->
              <NoData></NoData>
              <br />
            </template>
            <el-table-column prop="doctor_name" label="姓名">
              <template slot-scope="scope">
                <div>{{ scope.row.doctor_name ? scope.row.doctor_name : '-' }}</div>
                <div class="representimportid">
                  ID: {{ scope.row.doctor_id ? scope.row.doctor_id : '-' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="hospital_name" label="医院" />
            <el-table-column prop="is_registered" label="注册状态">
              <template slot-scope="scope">
                <div>{{ statusMap.isRegistered[scope.row.is_registered] }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="verify_status" label="认证状态">
              <template slot-scope="scope">
                <div>{{ statusMap.verifyStatus[scope.row.verify_status] }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="contract_status"
              label="签约状态"
              v-if="Object.keys(statusMap.contractStatus).length > 0"
            >
              <template slot-scope="scope">
                <div>{{ statusMap.contractStatus[scope.row.contract_status] }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="department_name" label="科室" />
            <el-table-column prop="title" label="职称" />
            <!-- <el-table-column prop="mobile" label="手机号" /> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="showDoctor(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          class="pagination"
          style="background-color: #ffffff"
          layout="total,sizes, prev, pager, next, jumper"
          :total="doctorTotal"
          :page-size="doctorSize"
          :current-page="doctorCurrentPage"
          :page-sizes="g_pageSizesConfig"
          @current-change="handleIndexChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <!-- <div v-else>
      <div class="release-list-noData">
        <img class="release-list-noData-img" :src="g_imgSrc.bgWhite" />
        <div class="release-list-noData-word">您暂无权限</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';
import {
  getDoctorListApi,
  QueryTitleList,
  getHospitalDepartmentListApi,
  GetKvList,
} from '@/api/setUp.js';
export default {
  name: 'DoctorManagement',
  components: {
    NoData,
    ExportExcel,
    ExportProgress,
  },
  data() {
    return {
      role: 1,
      // 搜索表单
      buttonLoading: false,
      departmentList: [],
      titleList: [],
      form: {
        department: '',
        hospital: '',
        doctor_name: '',
        verify_status: '', // 验证状态
        // representative_code:0, // 代表code
        // enterprise_id = 6 // 企业ID
        title_name: '',
        is_registered: '',
        contract_status: '',
      },
      // 表格
      doctorTableLoading: false,
      tableSetupList: [],
      statusMap: {
        isRegistered: {
          1: '未注册',
          2: '已注册',
        },
        contractStatus: {},
        verifyStatus: {
          1: '未验证',
          2: '已验证',
        },
      },
      // 分页
      doctorTotal: 0,
      doctorSize: 10,
      doctorCurrentPage: 1,

      excelData: [], // 导出excel
      isExportLoading: false,
    };
  },
  created() {
    this.doctorSize = this.g_pageSizeDefault;
    // this.getLoginerInfo();
    this.QueryHospitalDepartment();
    this.requestListData();
    this.getTitleList();
    this.getKvList();
    // this.getKvList().finally(() => {
    // });
  },
  methods: {
    // 获取操作员相关信息
    getLoginerInfo() {
      this.role = this.$store.state.user.managerLogin.role;
    },
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, '');
    },
    requestListData() {
      this.doctorTableLoading = true;
      const req = {
        page_index: this.doctorCurrentPage,
        page_size: this.doctorSize,
        doctor_name: this.trim(this.form.doctor_name),
        verify_status: this.form.verify_status,
        contract_status: this.form.contract_status,
        hospital_name: this.trim(this.form.hospital),
        department_name: this.form.department,
        title_name: this.form.title_name,
        is_registered: this.form.is_registered ? this.form.is_registered : 0,
      };
      getDoctorListApi(req)
        .then((res) => {
          this.tableSetupList = res.data;
          this.doctorTotal = res.total_num;
          // this.doctorSize = res.page_size;
          this.doctorTableLoading = false;
          this.buttonLoading = false;
        })
        .catch(() => {
          this.$message('查询失败');
          this.doctorTableLoading = false;
          this.buttonLoading = false;
        });
    },
    // 获取科室信息
    QueryHospitalDepartment() {
      getHospitalDepartmentListApi().then((res) => {
        this.departmentList = res.data;
      });
    },
    getTitleList() {
      QueryTitleList({ page_index: 1, page_size: 9999 })
        .then((res) => {
          this.titleList = res.data || [];
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取列表
    doctorOnSubmit() {
      this.buttonLoading = true;
      this.doctorCurrentPage = 1;
      this.requestListData();
    },
    showDoctor(row) {
      const id = row.doctor_id;
      this.g_tourl(`/saas/doctorInfo.html?doctor_id=${id}`);
    },
    handleIndexChange(val) {
      this.doctorCurrentPage = val;
      this.requestListData();
    },
    handleSizeChange(val) {
      this.doctorCurrentPage = 1;
      this.doctorSize = val;
      this.requestListData();
    },
    handleExportExcel() {
      this.isExportLoading = true;
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(30);
      const req = {
        doctor_name: this.trim(this.form.doctor_name),
        verify_status: this.form.verify_status,
        contract_status: this.form.contract_status,
        hospital_name: this.trim(this.form.hospital),
        department_name: this.form.department,
        title_name: this.form.title_name,
        is_registered: this.form.is_registered ? this.form.is_registered : 0,
      };
      getDoctorListApi({
        page_index: 1,
        page_size: 1,
        ...req,
      })
        .then((res) => {
          if (res.total_num > 50000) {
            this.$message.warning(`最大支持导出5万条数据，当前数据${res.total_num}条，请重新筛选`);
            this.$refs.downloadDialog.abortProgress();
            this.isExportLoading = false;
          } else {
            getDoctorListApi({
              page_index: 1,
              page_size: 50000,
              ...req,
            })
              .then((res) => {
                this.excelData = res.data.map((item) => {
                  return {
                    ...item,
                    is_registered: this.statusMap.isRegistered[item.is_registered] || '',
                    verify_status: this.statusMap.verifyStatus[item.verify_status] || '',
                    contract_status: this.statusMap.contractStatus[item.contract_status] || '',
                  };
                });
                this.$refs.downloadDialog.finishProgress(500);
              })
              .catch((e) => {
                this.$message.error(e);
                this.$refs.downloadDialog.abortProgress();
              });
          }
        })
        .catch((e) => {
          this.$message.error(e);
          this.$refs.downloadDialog.abortProgress();
        });
      this.isExportLoading = false;
    },
    getKvList() {
      GetKvList({ type: 'contract_status' })
        .then(({ list }) => {
          const temp = {};
          for (const item of list) {
            temp[Number.parseInt(item.key, 10)] = item.value;
          }
          this.statusMap.contractStatus = temp;
        })
        .catch((e) => {
          this.$message.error(e);
        });
      // GetKvList({ type: 'verify_status' })
      //   .then(({ list }) => {
      //     console.log(list);
      //     const temp = {};
      //     for (const item of list) {
      //       temp[Number.parseInt(item.key, 10)] = item.value;
      //     }
      //     this.statusMap.verifyStatus = temp;
      //   })
      //   .catch((e) => {
      //     this.$message.error(e);
      //   });
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
